document.addEventListener('DOMContentLoaded', () => {
  const tabContainer = document.querySelector('[data-filter-tabs]');
  if (!tabContainer) return;

  const gridContainer = document.querySelector('#ProductGridContainer');
  if (!gridContainer) return;

  const activeTags = new Set();

  tabContainer.addEventListener('click', async (e) => {
    const tab = e.target.closest('.filter-tab');
    if (!tab) return;

    const tag = tab.dataset.tag;

    if (tag === '') {
      activeTags.clear();
      tabContainer.querySelectorAll('.filter-tab').forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
    } else {
      tabContainer.querySelector('[data-tag=""]').classList.remove('active');
      if (activeTags.has(tag)) {
        activeTags.delete(tag);
        tab.classList.remove('active');
      } else {
        activeTags.add(tag);
        tab.classList.add('active');
      }
      if (activeTags.size === 0) {
        tabContainer.querySelector('[data-tag=""]').classList.add('active');
      }
    }

    await loadProducts([...activeTags]);
  });

  async function loadProducts(tags) {
    gridContainer.style.opacity = '0.4';
    gridContainer.style.pointerEvents = 'none';

    const urlParams = new URLSearchParams();
    tags.forEach(t => urlParams.append('filter.p.tag', t));
    // Verhindert Browser-Cache
    urlParams.set('_', Date.now());

    const fetchUrl = `${window.location.pathname}?${urlParams.toString()}`;
    console.log('Fetch URL:', fetchUrl);

    try {
      const response = await fetch(fetchUrl, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'text/html'
        }
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newContainer = doc.querySelector('#ProductGridContainer');

      if (newContainer) {
        gridContainer.innerHTML = newContainer.innerHTML;
        console.log('Grid aktualisiert ✓');
        checkEmptyState(tags);
      } else {
        console.warn('ProductGridContainer nicht in Antwort gefunden');
      }
    } catch (err) {
      console.error('Filter-Fehler:', err);
    } finally {
      gridContainer.style.opacity = '1';
      gridContainer.style.pointerEvents = 'auto';
    }
  }

  function checkEmptyState(tags) {
    const items = gridContainer.querySelectorAll('.grid__item');
    const existing = gridContainer.querySelector('.filter-tabs-empty');

    if (items.length === 0 && tags.length > 0) {
      if (!existing) {
        const empty = document.createElement('div');
        empty.className = 'filter-tabs-empty';
        empty.innerHTML = `
          <p>Keine Angebote? Dann lohnt sich ein Blick auf unsere
            <a href="#" class="filter-tabs-empty__link" data-tag="Neu">Neuheiten</a>.
          </p>`;
        gridContainer.appendChild(empty);

        empty.querySelector('.filter-tabs-empty__link').addEventListener('click', function(e) {
          e.preventDefault();
          const neuTab = tabContainer.querySelector('.filter-tab[data-tag="Neu"]');
          if (neuTab) neuTab.click();
        });
      }
    } else {
      if (existing) existing.remove();
    }
  }
});
